export default __webpack_public_path__ + "static/media/certidao01.cc4546c7.png";